// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import App from './App'
import Vue from 'vue'
import Vuex from 'vuex'
import router from './router'
import store from './store'
// import store from './store/store.js'

import compLoader from './components/Loader'

import axios from 'axios'
import VueAxios from 'vue-axios'
import VueKonva from 'vue-konva';

import VueMaterial from 'vue-material'
import 'vue-material/dist/vue-material.min.css'
import 'vue-material/dist/theme/default.css'

import VueI18n from 'vue-i18n'
import { messages } from './translations/messages'
import { lang } from './translations/lang'

// --------------------------------------
import './assets/css/main.css'

Vue.config.productionTip = false

axios.defaults.baseURL = process.env.VUE_APP_API

Vue.component('app-loader', compLoader)

Vue.use(Vuex)
Vue.use(VueAxios, axios)
Vue.use(VueMaterial)
Vue.use(VueKonva);

Vue.use(VueI18n)
// Create VueI18n instance with options
const i18n = new VueI18n({
  locale: lang, // set locale
  fallbackLocale: 'pl', // when no EN translate
  messages // set locale messages
  // numberFormats
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js